import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.RocketRepair;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "RocketRepair.Phaser.IntroductionScene.1",
            "RocketRepair.Phaser.IntroductionScene.2",
            "RocketRepair.Phaser.IntroductionScene.3",
            "RocketRepair.Phaser.IntroductionScene.4",
            "RocketRepair.Phaser.IntroductionScene.5",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/RocketRepairGame/scenes/GameIntro.ts